import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthState } from '@app/store/auth/auth.state';
import { Store } from '@ngxs/store';
import { ToastrService } from 'ngx-toastr';
import { StateResetAll } from 'ngxs-reset-plugin';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private _store: Store,
    private _toastrService: ToastrService
  ) {}

  canActivate(next?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): boolean {
    const { token } = this._store.selectSnapshot(AuthState);

    if (token) {
      return true;
    }

    this._store.dispatch(new StateResetAll());
    this.router.navigate(['login']);
    this._toastrService.warning('Sua sessão expirou. Realize a autenticação novamente!');
    return false;
  }
}
